const OPEN_STORAGE_KEY = 'embedded-sidebar-open'

export function readSidebarOpenFromStorage(): boolean {
  try {
    const stored = localStorage.getItem(OPEN_STORAGE_KEY)
    if (stored === null) return false
    return stored === 'true'
  } catch {
    return false
  }
}

export function writeSidebarOpenToStorage(open: boolean) {
  try {
    localStorage.setItem(OPEN_STORAGE_KEY, String(open))
  } catch {
    // localStorage unavailable
  }
}
